const CONNECTION_LOG_PREFIX = '[Connection]';

/** Player-facing overlay stays generic; these logs are for developers only. */
export function logConnection(event: string, extra?: unknown): void {
  if (extra !== undefined) {
    console.log(`${CONNECTION_LOG_PREFIX} ${event}`, extra);
    return;
  }
  console.log(`${CONNECTION_LOG_PREFIX} ${event}`);
}
